import { render, staticRenderFns } from "./depositOrWithdraw.vue?vue&type=template&id=b523aa9c&"
import script from "./depositOrWithdraw.vue?vue&type=script&lang=js&"
export * from "./depositOrWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./depositOrWithdraw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports